export default "__VITE_ASSET__99UPJbjt__"